import { useState } from "react";
import { MessageCircle } from "lucide-react";

const PHONE_E164 = "4924212633703"; // +49 (0)2421 263370-3 normalized for wa.me
const DEFAULT_MSG = encodeURIComponent(
  "Hallo Wertbild, ich interessiere mich für Ihre Immobilienfotografie und möchte gerne ein Projekt anfragen."
);

export default function WhatsAppButton() {
  const [hover, setHover] = useState(false);

  return (
    <a
      href={`https://wa.me/${PHONE_E164}?text=${DEFAULT_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-cta"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[60] flex items-center gap-3 group"
      aria-label="Kontakt via WhatsApp"
    >
      {/* Tooltip / label */}
      <span
        className={`hidden md:inline-flex items-center px-4 py-2.5 bg-[#1A1A1A] text-[#F5F2EC] text-xs uppercase tracking-[0.18em] font-medium border border-[#2A2A2A] shadow-[0_8px_24px_-8px_rgba(0,0,0,0.5)] transition-all duration-300 ${
          hover ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
        }`}
      >
        Schreiben Sie uns
      </span>
      <span className="relative inline-flex">
        <span className="wa-pulse absolute"></span>
        <span className="relative w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] rounded-full shadow-[0_12px_32px_-8px_rgba(37,211,102,0.65)] group-hover:scale-105 group-hover:bg-[#1FB855] transition-all duration-300">
          <svg viewBox="0 0 24 24" className="w-7 h-7 md:w-8 md:h-8 fill-white" aria-hidden>
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/>
          </svg>
        </span>
      </span>
    </a>
  );
}
